import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => (
          <SignInPage
            {...props}
            auto
            provider={{
              id: 'microsoft',
              title: 'Microsoft',
              message: 'Sign in with Microsoft',
              apiRef: microsoftAuthApiRef,
            }}
          />
        ),
      },
    }),
  ],
});